// extracted by mini-css-extract-plugin
export default {"root":"SubtopicsList_root__j8019","collection":"SubtopicsList_collection__ipOXM","block":"SubtopicsList_block__1Jwhy"};